import { createSignal } from '@react-rxjs/utils';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { tap } from 'rxjs';

export const [navigate$, navigate] = createSignal<string>();
export const useProgramaticNavigator = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const sub = navigate$
      .pipe(
        tap((path) => {
          navigate(path);
        })
      )
      .subscribe();

    return () => {
      sub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
